export default __webpack_public_path__ + "static/new7-07-4011e8d5368bab8f4a316f370caa3715.jpg";